<template>
  <div class="caseDetail">
    <div class="wrap">
      <Breadcrumb :breadcrumbs="breadcrumbs" />
      <div class="layout">
        <div class="main">
          <h1>{{ detailInfo.title }}</h1>
          <div class="tag">
            <span v-if="detailInfo.original">原创</span>
            <em>{{ detailInfo.publishTime }}</em>
            <em>{{ detailInfo.name }}</em>
            <em v-if="detailInfo.author">作者：{{ detailInfo.author }}</em>
            <em>访问次数：{{ detailInfo.hits }}</em>
            <em>点赞：{{ likeNum }}</em>
          </div>
          <div class="content" v-html="detailInfo.content"></div>
          <div class="action">
            <span @click="handlePraise" :class="{ active: isLike }"
              ><i class="praise"></i
              ><em>{{ isLike ? "已赞" : "点赞" }}</em></span
            >
            <span @click="handleCollect"
              ><i class="collect"></i><em>收藏</em></span
            >
          </div>
          <div class="original" v-if="detailInfo.original">
            本文著作权归SGS所有，商业转载请联系获得正式授权，非商业请注明出处
          </div>
          <div class="recommend" v-if="recommend.length">
            <dl>
              <dt>相关内容：</dt>
              <dd v-for="item of recommend" :key="item.id">
                <i></i>
                <!-- 这里的article要动态取别名 -->
                <a :href="'/case/article/detail-' + item.id + '.html'">{{
                  item.title
                }}</a>
              </dd>
            </dl>
          </div>
        </div>
        <div :class="{ side: true, fixed: isFixed }">
           <TicketInset :userInfo="userInfo" :env="env" v-bind="$attrs" />
        </div>
        <div :class="{ 'fixed-action': true, fixed: isFixed }">
          <span @click="handlePraise" :class="{ active: isLike }"
            ><i class="praise"></i
          ></span>
          <span @click="handleCollect"><i class="collect"></i></span>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="isShowLogin"
      width="900px"
      :append-to-body="appendToBody"
      custom-class="Modal_box"
      :show-close="closeBtn"
      :before-close="handleCloseLogin"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :lock-scroll="true"
    >
      <TicLoginMerge
        :env="env"
        :successCallback="successCallback"
        :parameter="parameter"
      >
      </TicLoginMerge>
    </el-dialog>
  </div>
</template>

<script>
import { host } from "src/config";
import {
  qryCaseDtl,
  caseRecommend,
  likeSet,
  likeStat,
  likeStatNumber,
  getUserInfo,
} from "../../request/portal";
import TicketInset from "./TicketInset.vue";
import Breadcrumb from "./Breadcrumb.vue";
import TicLoginMerge from "./../loginMerge/index.vue";

export default {
  name: "PortalCaseDetail",
  props: {
    env: {
      type: String,
      default: "local",
    },
    id: {
      type: Number,
      default: 0,
    },
    alias: {
      type: String,
      default: "article",
    },
    labName: {
      type: String,
      default: "第三方检测机构",
    },
  },
  components: {
    TicketInset,
    Breadcrumb,
    TicLoginMerge,
  },
  data() {
    return {
      // env: process.env.MODE,
      // domain: process.env.domain,
      host: host(this.env),
      breadcrumbs: [],
      detailInfo: {}, // 详情信息
      recommend: [], // 推荐列表
      isLogin: false, // 是否是登录状态
      closeBtn: true, // 隐藏关闭按钮
      isShowLogin: false, // 是否显示登陆弹窗
      appendToBody: true, // 是否固定显示
      isLike: false, // 是否点赞
      parameter: {}, // 提交的参数
      loginAction: false, // 是否是点赞拉起的弹窗
      userInfo: {},
      isFixed: false, // 固定定位
      likeNum: 0,
    };
  },
  methods: {
    /* 收藏 */
    handleCollect() {
      // this.$message.info("请使用 " + (navigator.userAgent.toLowerCase().indexOf("mac") != -1 ? "Command" : "CTRL") + " + D 加入收藏")
      window.alert(
        "请使用 " +
          (navigator.userAgent.toLowerCase().indexOf("mac") != -1
            ? "Command"
            : "CTRL") +
          " + D 加入收藏"
      );
    },
    // 点赞、取消点赞
    handlePraise() {
      // 是否登录，已登录才可以点赞，未登录拉起登录弹窗
      if (this.isLogin) {
        this.likeSetFun();
      } else {
        this.isShowLogin = true;
        this.loginAction = true;
      }
    },
    // 点赞事件
    likeSetFun() {
      likeSet(
        {
          likeType: `case-${this.detailInfo.catalogCode}`,
          businessCode: `${this.detailInfo.id}`,
          pageUrl: window.location.href,
          state: this.isLike ? 0 : 1,
        },
        this.host.nodeUrl
      ).then((res) => {
        if (res.resultCode === "0" || res.resultCode === "3831") {
          this.isLike = !this.isLike;
          if (this.isLike) {
            this.likeNum++;
          } else {
            this.likeNum--;
          }
          this.$message.success(`${!this.isLike ? "取消成功" : "点赞成功"}`);
          if (!this.isLogin) window.location.reload();
        } else if (res.resultCode === "9978") {
          Cookies.remove("SSO_TOKEN");
          this.isShowLogin = true;
          this.loginAction = true;
        } else {
          // this.$message({
          //   duration: 2000,
          //   message: res.resultMsg,
          //   type: "info",
          //   onClose: () => {
          //     window.location.reload();
          //   },
          // });
          // window.location.reload()
        }
      });
    },
    // 关闭登录弹窗
    handleCloseLogin() {
      this.isShowLogin = false;
    },
    // 登录成功后的回调
    successCallback() {
      if (this.loginAction) {
        this.isShowLogin = false;
        this.likeSetFun();
      } else {
        window.location.reload();
      }
    },
    // 滚动事件
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 177) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
  },
  mounted() {
    qryCaseDtl({ id: this.id }, this.host.nodeUrl).then((resDetail) => {
      this.detailInfo = resDetail.data;
      this.breadcrumbs = [
        {
          name: this.labName,
          link: "/",
        },
        {
          name: this.detailInfo.name,
          link: `/information?type=${this.detailInfo.classificationCatalogId}`,
        },
        {
          name: this.detailInfo.title,
        },
      ];
      getUserInfo({}, this.host.nodeUrl).then((res) => {
        if (res.resultCode === "0") {
          this.isLogin = true;
          this.userInfo = res.data;
        } else {
          if (this.detailInfo.isPublic) {
            this.closeBtn = false;
            this.isShowLogin = true;
          }
        }
      });
      likeStatNumber({ busiCode: this.id }, this.host.nodeUrl).then((res) => {
        if (res && res.data) this.likeNum = res.data.likeNum;
      });
      likeStat(
        {
          likeType: `case-${this.detailInfo.catalogCode}`,
          businessCode: this.id,
        },
        this.host.nodeUrl
      ).then((res) => {
        if (res.data) this.isLike = true;
      });
      this.$emit('emitCaseDetail', this.detailInfo)
    });
    // 提交注册的参数值
    this.parameter = {
      regMode: "case-" + this.detailInfo.catalogCode,
      regSource: "portal",
      regFrom: window.location.href,
      busiCode: this.detailInfo.id,
    };
    // 滚动监听
    window.addEventListener("scroll", this.handleScroll);
    caseRecommend(
      { caseId: this.id, pageRow: 10, pageNum: 1 },
      this.host.nodeUrl
    ).then((res) => {
      this.recommend = res.data.items;
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
@import "./../../assets/style/mixin.scss";

.caseDetail {
  background: #fff;
  padding: 25px 0;

  .layout {
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  .main {
    width: 750px;

    h1 {
      font-size: 32px;
      color: #000;
      margin: 0 0 30px 0;
    }

    .tag {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      height: 20px;
      margin-bottom: 20px;
      flex-wrap: wrap;

      span {
        width: 30px;
        text-align: center;
        height: 18px;
        line-height: 18px;
        font-size: 11px;
        background: #eee;
        border-radius: 3px;
        margin-right: 20px;
        color: #959595;
      }

      em {
        font-size: 14px;
        color: #646464;
        padding-right: 20px;
        border-right: 1px solid #e7e7e7;
        margin-right: 20px;

        &:last-child {
          border: none;
        }
      }
    }

    .content {
      font-size: 14px;
      line-height: 1.7;
      color: #000;
      margin-bottom: 30px;
      border-top: 1px solid #eee;
      padding-top: 20px;
    }

    .action {
      display: flex;
      justify-content: center;

      span {
        display: flex;
        width: 96px;
        height: 35px;
        align-items: center;
        justify-content: space-evenly;
        border: 1px solid #878787;
        border-radius: 35px;
        cursor: pointer;
        margin: 0 13px;

        &:hover,
        &.active {
          border: 1px solid $mainColor;

          em {
            color: $mainColor;
          }

          i {
            &.praise {
              background: url("./../../assets/images/case/praise-active.png")
                no-repeat center center;
            }

            &.collect {
              background: url("./../../assets/images/case/star-active.png")
                no-repeat center center;
            }
          }
        }

        em {
          font-size: 14px;
          color: #878787;
        }

        i {
          display: block;
          width: 18px;
          height: 18px;

          &.praise {
            background: url("./../../assets/images/case/praise.png") no-repeat
              center center;
          }

          &.collect {
            background: url("./../../assets/images/case/star.png") no-repeat
              center center;
          }
        }
      }
    }

    .original {
      background: #fff0e6;
      color: $mainColor;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 20px 0;
      font-size: 14px;
    }

    .recommend {
      margin-top: 15px;
      background: $innerBackgroupColor;
      padding: 30px 40px;

      dt {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        padding-bottom: 20px;
      }

      dd {
        height: 30px;
        line-height: 30px;
        display: flex;
        align-items: center;

        i {
          width: 3px;
          height: 3px;
          background: #b6b6b6;
          display: block;
        }

        a {
          color: #333;
          font-size: 14px;
          display: block;
          height: 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-left: 6px;

          &:hover {
            color: $mainColor;
          }
        }
      }
    }
  }

  .side {
    width: 360px;

    &.fixed {
      position: fixed;
      top: 0;
      right: calc(50% - 613px);
    }
  }

  .fixed-action {
    display: flex;
    position: absolute;
    left: calc(50% - 680px);
    // top: 30px;
    flex-direction: column;

    &.fixed {
      top: 50px;
    }

    span {
      width: 46px;
      height: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      cursor: pointer;
      margin-bottom: 18px;
      background: #f4f4f4;

      &:hover,
      &.active {
        background: $mainColor;

        i {
          &.collect {
            background: url("./../../assets/images/case/star1-active.png")
              no-repeat center center;
          }

          &.praise {
            background: url("./../../assets/images/case/praise1-active.png")
              no-repeat center center;
          }
        }
      }

      i {
        display: block;
        width: 23px;
        height: 23px;

        &.collect {
          background: url("./../../assets/images/case/star1.png") no-repeat
            center center;
        }

        &.praise {
          background: url("./../../assets/images/case/praise1.png") no-repeat
            center center;
        }
      }
    }
  }
}
</style>
